import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { DEV_TOOL_ICON_MAP } from "../data/devToolIcons";

export default function CategorySubServices({ children, subServiceCards = [], serviceCards = [], heading = "Sub Services", showTools = false }) {
  if (!children || children.length === 0) return null;

  return (
    <section className="relative bg-navy text-white py-16 md:py-20 border-b border-navy-border">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          {heading}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {children.map((child, i) => {
            // A leaf sub-service (e.g. CorePHP Development) has a SubServiceCard (matched by
            // subtitle). A category card (e.g. AI Document Tools, on a hub page) has its own
            // ServiceCard instead (matched by title).
            const card =
              subServiceCards.find((c) => c.subtitle === child.title) ||
              serviceCards.find((c) => c.title === child.title);
            return (
              <motion.div
                key={child.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.06 }}
                whileHover={{ y: -6 }}
                className="group relative rounded-xl bg-navy-dark border border-accent-light/25 shadow-[0_0_15px_rgba(34,211,238,0.2)] overflow-hidden transition-all duration-300 hover:border-accent-light hover:shadow-[0_0_35px_rgba(34,211,238,0.5)]"
              >
                <Link to={`/${child.slug}`} className="block">
                  <div className="relative bg-navy overflow-hidden">
                    {card?.image ? (
                      <img
                        src={card.image}
                        alt={child.title}
                        className="w-full h-auto block transition-transform duration-500 group-hover:scale-105"
                      />
                    ) : (
                      <div className="w-full h-40 bg-brand-gradient" />
                    )}
                  </div>
                  <div className="p-5">
                    <h3 className="font-semibold group-hover:text-accent-light transition-colors">
                      {child.title}
                    </h3>
                    {showTools && (() => {
                      const icons = (card?.icons || "").split(",").filter(Boolean);
                      if (icons.length === 0) return null;
                      return (
                        <div className="flex flex-wrap gap-1.5 mt-3">
                          {icons.map((key) => {
                            const entry = DEV_TOOL_ICON_MAP[key];
                            if (!entry) return null;
                            const { Icon, label } = entry;
                            return (
                              <span
                                key={key}
                                title={label}
                                className="flex items-center gap-1 px-2 py-1 rounded-md bg-white/5 border border-navy-border text-white/70 text-xs"
                              >
                                <Icon size={12} />
                              </span>
                            );
                          })}
                        </div>
                      );
                    })()}
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
